module.exports = __webpack_public_path__ + "static/img/yiban.854d2dd.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yiban.gif
// module id = wkmR
// module chunks = 1